module.exports = __webpack_public_path__ + "img/video-placeholder.f7a6f280.svg";